export type NearBreakInfo = {
  target?: 'up' | 'down'
  targetPct: number | null
  parent?: 'up' | 'down'
  parentPct: number | null
}

export function detectNearBreak(cfRaw: any, trendRaw: string): NearBreakInfo | null {
  const cf = cfRaw || {}
  const trend = String(trendRaw || '').toLowerCase()
  if (!cf || typeof cf !== 'object') return null

  const nearTargetBool = !!(cf.near_target_break || cf.near_break || cf.target_choch_risk)
  const nearParentBool = !!(cf.near_parent_break || cf.parent_break_risk)

  const tp = num(cf.target_break_proximity_pct ?? cf.target_break_distance_pct ?? cf.distance_to_prev_high_pct ?? cf.distance_to_prev_low_pct)
  const pp = num(cf.parent_break_proximity_pct ?? cf.parent_break_distance_pct)

  const dHigh = num(cf.distance_to_prev_high ?? cf.dist_prev_high)
  const dLow = num(cf.distance_to_prev_low ?? cf.dist_prev_low)
  const thr = 0.6

  let target: 'up'|'down'|undefined
  let parent: 'up'|'down'|undefined
  let targetPct: number | null = tp ?? null
  let parentPct: number | null = pp ?? null

  if (nearTargetBool) target = trend === 'bullish' || trend === 'alta' ? 'down' : 'up'
  if (nearParentBool) parent = trend === 'bullish' || trend === 'alta' ? 'down' : 'up'

  if (!target) {
    if (trend === 'bullish' && dLow !== null && dLow <= thr) { target = 'down'; targetPct = dLow }
    if (trend === 'bearish' && dHigh !== null && dHigh <= thr) { target = 'up'; targetPct = dHigh }
  }

  if (!target && targetPct !== null && targetPct <= thr) target = trend === 'bullish' || trend === 'alta' ? 'down' : 'up'
  if (!parent && parentPct !== null && parentPct <= thr) parent = trend === 'bullish' || trend === 'alta' ? 'down' : 'up'

  if (!target && !parent) return null
  return { target, targetPct, parent, parentPct }

  function num(v: any): number | null {
    if (v === undefined || v === null) return null
    const n = Number(v)
    return Number.isFinite(n) ? n : null
  }
}

